<template>
	<div ref="cc" id="popper_cc"
		class="v-popper__popper v-popper--theme-dropdown v-popper__popper--shown v-popper__popper--show-to"
		:class="{ active: $cc_on.value, 'empty': !text.length }" aria-hidden="false" tabindex="0" data-popper-placement="right">
		<div class="v-popper__backdrop"></div>
		<div class="v-popper__wrapper">
			<div class="v-popper__inner">
				<div>
					<div class="text-white">{{ text }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import srtParser2 from "srt-parser-2";

const component = {
	name: 'CC',
	data() {
		return {
			text: '',
			srt_data: [],
		};
	},
	created() {
		this.$watch('$subtitlesUrl.value', newVal => {
			this.srt_data = [];
			this.text = '';
			if (newVal !== undefined && newVal.length) {
				const parser = new srtParser2();
				fetch(newVal).then(r => r.text()).then(srt => {
					this.srt_data = parser.fromSrt(srt);
				}).catch(e => {
					console.log(e);
				});
			} else {

			}
		}, { immediate: true });
	},
	mounted() {
		this.emitter.on('audio-time-change', time => {
			if (this.srt_data.length) {
				const textItem = this.srt_data.find(el => {
					return time > el.startSeconds && time < el.endSeconds;
				});
				if (textItem !== undefined) {
					this.text = textItem.text;
				}
			}
		});

		this.emitter.on('audio-playback-finish', () => {
			this.text = '';
		});
	},
}

export default component;
</script>

<style lang="scss">
#popper_cc {
	position: fixed;
	width: 450px;
	display: none;
	bottom: 66px;
	top: initial;
	right: 12%;
	left: initial;
	transition: 0.5s;
	font-family: "american-typewriter", "Courier New", Courier, monospace;

	@media(max-width: 600px) {
		width: 95%;
		bottom: 180px;
		right: 50%;
		transform: translateX(50%);
		font-size: 12px;
		text-align: center;
		z-index: 6;
	}

	&.active {
		display: block;
	}

	&.empty {
		opacity: 0;
		visibility: hidden;
	}

	.v-popper__inner {
		padding: 15px;
	}
}
</style>
